/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceUploadUrlRequestDto
 */
export interface InvoiceUploadUrlRequestDto {
    /**
     * Original file name
     * @type {string}
     * @memberof InvoiceUploadUrlRequestDto
     */
    fileName: string;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof InvoiceUploadUrlRequestDto
     */
    fileType: string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof InvoiceUploadUrlRequestDto
     */
    fileSize?: number;
}

/**
 * Check if a given object implements the InvoiceUploadUrlRequestDto interface.
 */
export function instanceOfInvoiceUploadUrlRequestDto(value: object): value is InvoiceUploadUrlRequestDto {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    return true;
}

export function InvoiceUploadUrlRequestDtoFromJSON(json: any): InvoiceUploadUrlRequestDto {
    return InvoiceUploadUrlRequestDtoFromJSONTyped(json, false);
}

export function InvoiceUploadUrlRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceUploadUrlRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileType': json['fileType'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
    };
}

export function InvoiceUploadUrlRequestDtoToJSON(json: any): InvoiceUploadUrlRequestDto {
    return InvoiceUploadUrlRequestDtoToJSONTyped(json, false);
}

export function InvoiceUploadUrlRequestDtoToJSONTyped(value?: InvoiceUploadUrlRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'fileType': value['fileType'],
        'fileSize': value['fileSize'],
    };
}

